// Small helper for the school profile stored on this device (browser).
// Used on the letterhead and in the report dialog.
const KEY = "pm_poshan_school_info_v1";

export function getSchoolInfo() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : { name: "", udise: "" };
  } catch {
    return { name: "", udise: "" };
  }
}

export function saveSchoolInfo(info) {
  localStorage.setItem(KEY, JSON.stringify({ name: info.name || "", udise: info.udise || "" }));
}
